/*!
 * Copyright (c) 2017-present Cliqz GmbH. All rights reserved.
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */
/* eslint-disable prettier/prettier */
export default [
  "||imasdk.googleapis.com/js",
  "image,redirect-rule=1x1.gi",
  "redirect-rule=google-ima.j",
  "securepubads.g.doubleclick",
  "/pagead/js/adsbygoogle.js",
  "*$script,3p,denyallow=",
  "/wp-content/plugins/",
  "/wp-content/uploads/",
  ",redirect-rule=noop",
  "/sdkloader/ima3.js",
  ".com^$third-party",
  "googlesyndication",
  ".cloudfront.net^",
  "$script,domain=",
  ",redirect=noop",
  "xmlhttprequest",
  ".actonservice",
  "/^https?:\\/\\/",
  "^$third-party",
  "||smetrics.",
  "|downdetect",
  "third-party",
  "-9a-zA-Z]{",
  "marketing.",
  ".website^",
  "$subdocum",
  "analytics",
  "/assets/",
  "cloudfla",
  "tracking",
  "$script",
  "domain=",
  "metrics",
  ".co.uk",
  "$ghide",
  "a8clk.",
  "cookie",
  "google",
  "script",
  ".com^",
  ".top^",
  ".xyz^",
  "a-z]{",
  "a8cv.",
  "image",
  "media",
  "track",
  "video",
  ".com",
  ".gif",
  ".jp^",
  ".net",
  ".php",
  "/js/",
  "$doc",
  "$xhr",
  "html",
  "ight",
  "stat",
  "view",
  "www.",
  ",1p",
  ".de",
  ".io",
  ".jp",
  ".js",
  "$3p",
  "aff",
  "cdn",
  "new",
  "pro",
  "web",
  "-c",
  ".b",
  ".c",
  ".m",
  ".n",
  ".p",
  ".s",
  "@@",
  "*/",
  "/*",
  "/b",
  "/p",
  "||",
  "ab",
  "ac",
  "ad",
  "af",
  "ag",
  "ak",
  "al",
  "am",
  "an",
  "ap",
  "ar",
  "as",
  "at",
  "au",
  "av",
  "aw",
  "ay",
  "az",
  "be",
  "bo",
  "br",
  "ce",
  "ch",
  "ck",
  "cl",
  "ct",
  "de",
  "di",
  "do",
  "e-",
  "e^",
  "eb",
  "ec",
  "ed",
  "el",
  "em",
  "en",
  "ep",
  "er",
  "es",
  "et",
  "ev",
  "ex",
  "ff",
  "fi",
  "fo",
  "fr",
  "g^",
  "ge",
  "go",
  "gr",
  "he",
  "ho",
  "ib",
  "ic",
  "id",
  "if",
  "ig",
  "ik",
  "il",
  "im",
  "in",
  "ip",
  "ir",
  "is",
  "it",
  "iv",
  "ix",
  "iz",
  "js",
  "le",
  "lo",
  "ly",
  "ma",
  "mo",
  "mp",
  "no",
  "ob",
  "od",
  "ok",
  "ol",
  "om",
  "on",
  "op",
  "or",
  "ot",
  "pl",
  "po",
  "pr",
  "qu",
  "re",
  "ro",
  "ru",
  "s/",
  "sc",
  "se",
  "sh",
  "sm",
  "so",
  "sp",
  "ss",
  "st",
  "th",
  "ti",
  "to",
  "tr",
  "ts",
  "tv",
  "ub",
  "ud",
  "ug",
  "ul",
  "um",
  "un",
  "up",
  "ur",
  "us",
  "ut",
  "ve",
  "yo",
  "_",
  "-",
  ",",
  "?",
  ".",
  "*",
  "/",
  "\\",
  "^",
  "=",
  "|",
  "~",
  "$",
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z"
];